const initialState = {
  showLoading: false,
  auth: {
    isAuthenticated: false,
    user: {},
  },
  profile: {},
  errors: {}
};

export default initialState;



// WEBPACK FOOTER //
// ./src/features/app/redux/initialState.js